import { IpaOptions, makeFromPattern } from "./makeFromPattern";
import { Pattern } from "./pattern";
import { PhonemeInfo } from "./phonemeInfo";
import { IpaType } from "../phonemes/ipa";
import { PatternError, stringToPattern } from "./stringToPattern";

/** a factory for making words from patterns */
export class MakeFromPatterns {
  private patterns: Pattern<PhonemeInfo>[] = [];

  constructor(private readonly options: IpaOptions) { }

  setPatterns(patterns: Pattern<PhonemeInfo>[]) { this.patterns = patterns; }

  /** parse a set of patterns, e.g., 'C(C)V  {S|F}VC' */
  parsePatterns(s: string): true | PatternError {
    const pieces = s.split(/\s/g).filter(s => s !== '')
    for (const piece of pieces) {
      const pattern = stringToPattern(piece);
      if ('error' in pattern) {
        return pattern;
      }
      this.patterns.push(pattern);
    }
    return true;
  }

  /** generate a word - randomly pick a pattern, then randomly make a word with that pattern */
  makeWord(): IpaType {
    if (this.patterns.length === 0) {
      return '';
    }
    const n = randomInt(this.patterns.length);
    return makeFromPattern(this.patterns[n], this.options).join('');
  }
}

/** random int in [0, n) */
function randomInt(n: number): number {
  return Math.floor(Math.random() * n);
}
